// src/components/Tag.tsx
import PO_BD_LO_01 from "../assets/image/PO_BD_LO_01.svg";
import PO_BD_LO_02 from "../assets/image/PO_BD_LO_02.svg";
import PO_BD_LO_03 from "../assets/image/PO_BD_LO_03.svg";
import PO_BD_LO_04 from "../assets/image/PO_BD_LO_04.svg";
import PO_BD_LO_05 from "../assets/image/PO_BD_LO_05.svg";
import PO_BD_LO_06 from "../assets/image/PO_BD_LO_06.svg";
import PO_BD_LO_07 from "../assets/image/PO_BD_LO_07.svg";
import PO_BD_LO_08 from "../assets/image/PO_BD_LO_08.svg";

import PO_BD_ST_01 from "../assets/image/PO_BD_ST_01.svg";
import PO_BD_ST_02 from "../assets/image/PO_BD_ST_02.svg";
import PO_BD_ST_03 from "../assets/image/PO_BD_ST_03.svg";
import PO_BD_ST_04 from "../assets/image/PO_BD_ST_04.svg";
import PO_BD_ST_05 from "../assets/image/PO_BD_ST_05.svg";
import PO_BD_ST_06 from "../assets/image/PO_BD_ST_06.svg";
import PO_BD_ST_07 from "../assets/image/PO_BD_ST_07.svg";

import PO_BD_MT_01 from "../assets/image/PO_BD_MT_01.svg";
import PO_BD_MT_02 from "../assets/image/PO_BD_MT_02.svg";
import PO_BD_MT_03 from "../assets/image/PO_BD_MT_03.svg";
import PO_BD_MT_04 from "../assets/image/PO_BD_MT_04.svg";
import PO_BD_MT_05 from "../assets/image/PO_BD_MT_05.svg";
import PO_BD_MT_06 from "../assets/image/PO_BD_MT_06.svg";
import PO_BD_MT_07 from "../assets/image/PO_BD_MT_07.svg";

import NE_BD_LO_01 from "../assets/image/NE_BD_LO_01.svg";
import NE_BD_LO_02 from "../assets/image/NE_BD_LO_02.svg";
import NE_BD_LO_03 from "../assets/image/NE_BD_LO_03.svg";
import NE_BD_LO_04 from "../assets/image/NE_BD_LO_04.svg";
import NE_BD_LO_05 from "../assets/image/NE_BD_LO_05.svg";
import NE_BD_LO_06 from "../assets/image/NE_BD_LO_06.svg";
import NE_BD_LO_07 from "../assets/image/NE_BD_LO_07.svg";
import NE_BD_LO_08 from "../assets/image/NE_BD_LO_08.svg";

import NE_BD_ST_01 from "../assets/image/NE_BD_ST_01.svg";
import NE_BD_ST_02 from "../assets/image/NE_BD_ST_02.svg";
import NE_BD_ST_03 from "../assets/image/NE_BD_ST_03.svg";
import NE_BD_ST_04 from "../assets/image/NE_BD_ST_04.svg";
import NE_BD_ST_05 from "../assets/image/NE_BD_ST_05.svg";
import NE_BD_ST_06 from "../assets/image/NE_BD_ST_06.svg";
import NE_BD_ST_07 from "../assets/image/NE_BD_ST_07.svg";

import NE_BD_MT_01 from "../assets/image/NE_BD_MT_01.svg";
import NE_BD_MT_02 from "../assets/image/NE_BD_MT_02.svg";
import NE_BD_MT_03 from "../assets/image/NE_BD_MT_03.svg";
import NE_BD_MT_04 from "../assets/image/NE_BD_MT_04.svg";
import NE_BD_MT_05 from "../assets/image/NE_BD_MT_05.svg";
import NE_BD_MT_06 from "../assets/image/NE_BD_MT_06.svg";
import NE_BD_MT_07 from "../assets/image/NE_BD_MT_07.svg";

import PO_AG_PD_01 from "../assets/image/PO_AG_PD_01.svg";
import PO_AG_PD_02 from "../assets/image/PO_AG_PD_02.svg";
import PO_AG_PD_03 from "../assets/image/PO_AG_PD_03.svg";
import PO_AG_PD_04 from "../assets/image/PO_AG_PD_04.svg";
import PO_AG_PD_05 from "../assets/image/PO_AG_PD_05.svg";

import PO_AG_SO_01 from "../assets/image/PO_AG_SO_01.svg";
import PO_AG_SO_02 from "../assets/image/PO_AG_SO_02.svg";
import PO_AG_SO_03 from "../assets/image/PO_AG_SO_03.svg";
import PO_AG_SO_04 from "../assets/image/PO_AG_SO_04.svg";
import PO_AG_SO_05 from "../assets/image/PO_AG_SO_05.svg";
import PO_AG_SO_06 from "../assets/image/PO_AG_SO_06.svg";
import PO_AG_SO_07 from "../assets/image/PO_AG_SO_07.svg";

import NE_AG_PD_01 from "../assets/image/NE_AG_PD_01.svg";
import NE_AG_PD_02 from "../assets/image/NE_AG_PD_02.svg";
import NE_AG_PD_03 from "../assets/image/NE_AG_PD_03.svg";
import NE_AG_PD_04 from "../assets/image/NE_AG_PD_04.svg";

import NE_AG_SO_01 from "../assets/image/NE_AG_SO_01.svg";
import NE_AG_SO_02 from "../assets/image/NE_AG_SO_02.svg";
import NE_AG_SO_03 from "../assets/image/NE_AG_SO_03.svg";
import NE_AG_SO_04 from "../assets/image/NE_AG_SO_04.svg";
import NE_AG_SO_05 from "../assets/image/NE_AG_SO_05.svg";
import NE_AG_SO_06 from "../assets/image/NE_AG_SO_06.svg";
import NE_AG_SO_07 from "../assets/image/NE_AG_SO_07.svg";

import PO_DO_LO_01 from "../assets/image/dorm/PO_DO_LO_01.svg";
import PO_DO_LO_02 from "../assets/image/dorm/PO_DO_LO_02.svg";
import PO_DO_LO_03 from "../assets/image/dorm/PO_DO_LO_03.svg";
import PO_DO_LO_04 from "../assets/image/dorm/PO_DO_LO_04.svg";
import PO_DO_LO_05 from "../assets/image/dorm/PO_DO_LO_05.svg";
import PO_DO_LO_06 from "../assets/image/dorm/PO_DO_LO_06.svg";

import PO_DO_ST_01 from "../assets/image/dorm/PO_DO_ST_01.svg";
import PO_DO_ST_02 from "../assets/image/dorm/PO_DO_ST_02.svg";
import PO_DO_ST_03 from "../assets/image/dorm/PO_DO_ST_03.svg";
import PO_DO_ST_04 from "../assets/image/dorm/PO_DO_ST_04.svg";
import PO_DO_ST_05 from "../assets/image/dorm/PO_DO_ST_05.svg";
import PO_DO_ST_06 from "../assets/image/dorm/PO_DO_ST_06.svg";
import PO_DO_ST_07 from "../assets/image/dorm/PO_DO_ST_07.svg";

import PO_DO_MT_01 from "../assets/image/dorm/PO_DO_MT_01.svg";
import PO_DO_MT_02 from "../assets/image/dorm/PO_DO_MT_02.svg";
import PO_DO_MT_03 from "../assets/image/dorm/PO_DO_MT_03.svg";
import PO_DO_MT_04 from "../assets/image/dorm/PO_DO_MT_04.svg";
import PO_DO_MT_05 from "../assets/image/dorm/PO_DO_MT_05.svg";
import PO_DO_MT_06 from "../assets/image/dorm/PO_DO_MT_06.svg";
import PO_DO_MT_07 from "../assets/image/dorm/PO_DO_MT_07.svg";
import PO_DO_MT_08 from "../assets/image/dorm/PO_DO_MT_08.svg";
import PO_DO_MT_09 from "../assets/image/dorm/PO_DO_MT_09.svg";
import PO_DO_MT_10 from "../assets/image/dorm/PO_DO_MT_10.svg";
import PO_DO_MT_11 from "../assets/image/dorm/PO_DO_MT_11.svg";

import NE_DO_LO_01 from "../assets/image/dorm/NE_DO_LO_01.svg";
import NE_DO_LO_02 from "../assets/image/dorm/NE_DO_LO_02.svg";
import NE_DO_LO_03 from "../assets/image/dorm/NE_DO_LO_03.svg";
import NE_DO_LO_04 from "../assets/image/dorm/NE_DO_LO_04.svg";
import NE_DO_LO_05 from "../assets/image/dorm/NE_DO_LO_05.svg";
import NE_DO_LO_06 from "../assets/image/dorm/NE_DO_LO_06.svg";

import NE_DO_ST_01 from "../assets/image/dorm/NE_DO_ST_01.svg";
import NE_DO_ST_02 from "../assets/image/dorm/NE_DO_ST_02.svg";
import NE_DO_ST_03 from "../assets/image/dorm/NE_DO_ST_03.svg";
import NE_DO_ST_04 from "../assets/image/dorm/NE_DO_ST_04.svg";
import NE_DO_ST_05 from "../assets/image/dorm/NE_DO_ST_05.svg";
import NE_DO_ST_06 from "../assets/image/dorm/NE_DO_ST_06.svg";
import NE_DO_ST_07 from "../assets/image/dorm/NE_DO_ST_07.svg";

import NE_DO_MT_01 from "../assets/image/dorm/NE_DO_MT_01.svg";
import NE_DO_MT_02 from "../assets/image/dorm/NE_DO_MT_02.svg";
import NE_DO_MT_03 from "../assets/image/dorm/NE_DO_MT_03.svg";
import NE_DO_MT_04 from "../assets/image/dorm/NE_DO_MT_04.svg";
import NE_DO_MT_05 from "../assets/image/dorm/NE_DO_MT_05.svg";
import NE_DO_MT_06 from "../assets/image/dorm/NE_DO_MT_06.svg";
import NE_DO_MT_07 from "../assets/image/dorm/NE_DO_MT_07.svg";
import NE_DO_MT_08 from "../assets/image/dorm/NE_DO_MT_08.svg";
import NE_DO_MT_09 from "../assets/image/dorm/NE_DO_MT_09.svg";
import NE_DO_MT_10 from "../assets/image/dorm/NE_DO_MT_10.svg";
import NE_DO_MT_11 from "../assets/image/dorm/NE_DO_MT_11.svg";

export const tagImages: { [key: string]: string } = {
  PO_BD_LO_01,
  PO_BD_LO_02,
  PO_BD_LO_03,
  PO_BD_LO_04,
  PO_BD_LO_05,
  PO_BD_LO_06,
  PO_BD_LO_07,
  PO_BD_LO_08,
  PO_BD_ST_01,
  PO_BD_ST_02,
  PO_BD_ST_03,
  PO_BD_ST_04,
  PO_BD_ST_05,
  PO_BD_ST_06,
  PO_BD_ST_07,
  PO_BD_MT_01,
  PO_BD_MT_02,
  PO_BD_MT_03,
  PO_BD_MT_04,
  PO_BD_MT_05,
  PO_BD_MT_06,
  PO_BD_MT_07,

  NE_BD_LO_01,
  NE_BD_LO_02,
  NE_BD_LO_03,
  NE_BD_LO_04,
  NE_BD_LO_05,
  NE_BD_LO_06,
  NE_BD_LO_07,
  NE_BD_LO_08,
  NE_BD_ST_01,
  NE_BD_ST_02,
  NE_BD_ST_03,
  NE_BD_ST_04,
  NE_BD_ST_05,
  NE_BD_ST_06,
  NE_BD_ST_07,
  NE_BD_MT_01,
  NE_BD_MT_02,
  NE_BD_MT_03,
  NE_BD_MT_04,
  NE_BD_MT_05,
  NE_BD_MT_06,
  NE_BD_MT_07,

  PO_AG_PD_01,
  PO_AG_PD_02,
  PO_AG_PD_03,
  PO_AG_PD_04,
  PO_AG_PD_05,
  PO_AG_SO_01,
  PO_AG_SO_02,
  PO_AG_SO_03,
  PO_AG_SO_04,
  PO_AG_SO_05,
  PO_AG_SO_06,
  PO_AG_SO_07,

  NE_AG_PD_01,
  NE_AG_PD_02,
  NE_AG_PD_03,
  NE_AG_PD_04,
  NE_AG_SO_01,
  NE_AG_SO_02,
  NE_AG_SO_03,
  NE_AG_SO_04,
  NE_AG_SO_05,
  NE_AG_SO_06,
  NE_AG_SO_07,

  PO_DO_LO_01,
  PO_DO_LO_02,
  PO_DO_LO_03,
  PO_DO_LO_04,
  PO_DO_LO_05,
  PO_DO_LO_06,
  PO_DO_ST_01,
  PO_DO_ST_02,
  PO_DO_ST_03,
  PO_DO_ST_04,
  PO_DO_ST_05,
  PO_DO_ST_06,
  PO_DO_ST_07,
  PO_DO_MT_01,
  PO_DO_MT_02,
  PO_DO_MT_03,
  PO_DO_MT_04,
  PO_DO_MT_05,
  PO_DO_MT_06,
  PO_DO_MT_07,
  PO_DO_MT_08,
  PO_DO_MT_09,
  PO_DO_MT_10,
  PO_DO_MT_11,

  NE_DO_LO_01,
  NE_DO_LO_02,
  NE_DO_LO_03,
  NE_DO_LO_04,
  NE_DO_LO_05,
  NE_DO_LO_06,
  NE_DO_ST_01,
  NE_DO_ST_02,
  NE_DO_ST_03,
  NE_DO_ST_04,
  NE_DO_ST_05,
  NE_DO_ST_06,
  NE_DO_ST_07,
  NE_DO_MT_01,
  NE_DO_MT_02,
  NE_DO_MT_03,
  NE_DO_MT_04,
  NE_DO_MT_05,
  NE_DO_MT_06,
  NE_DO_MT_07,
  NE_DO_MT_08,
  NE_DO_MT_09,
  NE_DO_MT_10,
  NE_DO_MT_11,  
};

export const tagMessages: { [key: string]: string } = {
  // ✅ 긍정 키워드
  PO_BD_LO_01: "교통 편리",
  PO_BD_LO_02: "깨끗한 환경",
  PO_BD_LO_03: "조용한 동네",
  PO_BD_LO_04: "가까운 공원",
  PO_BD_LO_05: "편의 가까움",
  PO_BD_LO_06: "학교 가까움",
  PO_BD_LO_07: "안전한 동네",
  PO_BD_LO_08: "친절한 이웃",

  PO_BD_ST_01: "좋은 채광",
  PO_BD_ST_02: "좋은 통풍",
  PO_BD_ST_03: "좋은 방음",
  PO_BD_ST_04: "세련된 신축",
  PO_BD_ST_05: "곰팡이 없음",
  PO_BD_ST_06: "냉난방 좋음",
  PO_BD_ST_07: "배수,수압 좋음",

  PO_BD_MT_01: "주차 편리",
  PO_BD_MT_02: "엘리베이터",
  PO_BD_MT_03: "쓰레기 용이",
  PO_BD_MT_04: "관리비 합리",
  PO_BD_MT_05: "인터넷 용이",
  PO_BD_MT_06: "정기적 관리",
  PO_BD_MT_07: "편리한 이사",

  PO_AG_PD_01: "매물 다양",
  PO_AG_PD_02: "검증된 매물",
  PO_AG_PD_03: "조건 맞춤",
  PO_AG_PD_04: "수수료 적정",
  PO_AG_PD_05: "매물 비교 상세",

  PO_AG_SO_01: "친절 응대",
  PO_AG_SO_02: "자세한 설명",
  PO_AG_SO_03: "원활한 대화",
  PO_AG_SO_04: "신뢰 있음",
  PO_AG_SO_05: "안전한 거래",
  PO_AG_SO_06: "투명한 계약",
  PO_AG_SO_07: "보장된 사후",

  PO_DO_LO_01: "교통 편리",
  PO_DO_LO_02: "깨끗한 환경",
  PO_DO_LO_03: "조용한 주변",
  PO_DO_LO_04: "편의 가까움",
  PO_DO_LO_05: "학교 가까움",
  PO_DO_LO_06: "안전한 주변",

  PO_DO_ST_01: "좋은 채광",
  PO_DO_ST_02: "좋은 통풍",
  PO_DO_ST_03: "좋은 방음",
  PO_DO_ST_04: "세련된 신축",
  PO_DO_ST_05: "곰팡이 없음",
  PO_DO_ST_06: "냉난방 좋음",
  PO_DO_ST_07: "배수,수압 좋음",
  
  PO_DO_MT_01: "주차 편리",
  PO_DO_MT_02: "엘리베이터",
  PO_DO_MT_03: "쓰레기 용이",
  PO_DO_MT_04: "입주비 합리",
  PO_DO_MT_05: "인터넷 용이",
  PO_DO_MT_06: "정기적 관리",
  PO_DO_MT_07: "편리한 이사",
  PO_DO_MT_08: "공용시설 쾌적",
  PO_DO_MT_09: "통금 없음",
  PO_DO_MT_10: "휴게시설 충분",
  PO_DO_MT_11: "규칙 유연",

  // ✅ 부정 키워드
  NE_BD_LO_01: "교통 불편",
  NE_BD_LO_02: "환경 나쁨",
  NE_BD_LO_03: "동네 시끄러움",
  NE_BD_LO_04: "공원 멂",
  NE_BD_LO_05: "생활권 불편",
  NE_BD_LO_06: "학교 멂",
  NE_BD_LO_07: "불안한 동네",
  NE_BD_LO_08: "불친절한 이웃",

  NE_BD_ST_01: "채광 부족",
  NE_BD_ST_02: "통풍 안됨",
  NE_BD_ST_03: "방음 안됨",
  NE_BD_ST_04: "집이 낡음",
  NE_BD_ST_05: "곰팡이 많음",
  NE_BD_ST_06: "냉난방 나쁨",
  NE_BD_ST_07: "배수,수압 약함",

  NE_BD_MT_01: "주차 불편",
  NE_BD_MT_02: "계단만 있음",
  NE_BD_MT_03: "쓰레기 불편",
  NE_BD_MT_04: "관리비 비쌈",
  NE_BD_MT_05: "인터넷 느림",
  NE_BD_MT_06: "관리 부족",
  NE_BD_MT_07: "불편한 이사",

  NE_AG_PD_01: "적은 매물",
  NE_AG_PD_02: "허위 매물",
  NE_AG_PD_03: "조건 안 맞음",
  NE_AG_PD_04: "높은 수수료",

  NE_AG_SO_01: "응대 불친절",
  NE_AG_SO_02: "부족한 설명",
  NE_AG_SO_03: "정보 숨김",
  NE_AG_SO_04: "처리 느림",
  NE_AG_SO_05: "계약 강요",
  NE_AG_SO_06: "부실한 계약",
  NE_AG_SO_07: "미흡한 사후",

  NE_DO_LO_01: "교통 불편",
  NE_DO_LO_02: "환경 나쁨",
  NE_DO_LO_03: "시끄러움",
  NE_DO_LO_04: "생활권 불편",
  NE_DO_LO_05: "학교 멃",
  NE_DO_LO_06: "불안한 동네",

  NE_DO_ST_01: "채광 부족",
  NE_DO_ST_02: "통풍 안됨",
  NE_DO_ST_03: "방음 안됨",
  NE_DO_ST_04: "건물 낡음",
  NE_DO_ST_05: "곰팡이 많음",
  NE_DO_ST_06: "냉난방 나쁨",
  NE_DO_ST_07: "배수,수압 약함",
  
  NE_DO_MT_01: "주차 불편",
  NE_DO_MT_02: "계단만 있음",
  NE_DO_MT_03: "쓰레기 불편",
  NE_DO_MT_04: "입주비 비쌈",
  NE_DO_MT_05: "인터넷 느림",
  NE_DO_MT_06: "관리 부족",
  NE_DO_MT_07: "불편한 이사",
  NE_DO_MT_08: "공용시설 불편",
  NE_DO_MT_09: "통금 있음",
  NE_DO_MT_10: "휴게시설 부족",
  NE_DO_MT_11: "규칙 엄격",
};

export const tagLongMessages: { [key: string]: string } = {
  // ✅ 긍정 키워드
  PO_BD_LO_01: "교통이 편리해요",
  PO_BD_LO_02: "주변 환경이 깨끗해요",
  PO_BD_LO_03: "동네가 조용해요",
  PO_BD_LO_04: "공원이 가까워요",
  PO_BD_LO_05: "생활권이 편리해요",
  PO_BD_LO_06: "학교와 가까워요",
  PO_BD_LO_07: "동네가 안전해요",
  PO_BD_LO_08: "이웃들이 친절해요",

  PO_BD_ST_01: "채광이 좋아요",
  PO_BD_ST_02: "통풍이 잘 돼요",
  PO_BD_ST_03: "방음이 잘 돼요",
  PO_BD_ST_04: "신축이라 세련됐어요",
  PO_BD_ST_05: "곰팡이가 없어요",
  PO_BD_ST_06: "냉난방이 잘 돼요",
  PO_BD_ST_07: "배수와 수압이 좋아요",

  PO_BD_MT_01: "주차가 편리해요",
  PO_BD_MT_02: "엘리베이터가 있어요",
  PO_BD_MT_03: "쓰레기 처리가 편해요",
  PO_BD_MT_04: "관리비가 합리적이에요",
  PO_BD_MT_05: "인터넷이 잘 돼요",
  PO_BD_MT_06: "관리가 정기적이에요",
  PO_BD_MT_07: "이사가 편했어요",

  PO_AG_PD_01: "매물이 다양해요",
  PO_AG_PD_02: "검증된 매물을 소개해줘요",
  PO_AG_PD_03: "조건에 맞는 매물을 추천해줘요",
  PO_AG_PD_04: "수수료가 합리적이에요",
  PO_AG_PD_05: "매물 비교를 잘해줘요",

  PO_AG_SO_01: "친절하게 응대해요",
  PO_AG_SO_02: "설명이 자세했어요",
  PO_AG_SO_03: "대화가 잘 통했어요",
  PO_AG_SO_04: "신뢰가 느껴졌어요",
  PO_AG_SO_05: "거래 방식이 안전했어요",
  PO_AG_SO_06: "계약 과정이 투명했어요",
  PO_AG_SO_07: "사후 대응이 잘 되었어요",

  PO_DO_LO_01: "교통이 편리해요",
  PO_DO_LO_02: "주변 환경이 깨끗해요",
  PO_DO_LO_03: "주변이 조용해요",
  PO_DO_LO_04: "생활권이 편리해요",
  PO_DO_LO_05: "학교와 가까워요",
  PO_DO_LO_06: "주변이 안전해요",

  PO_DO_ST_01: "채광이 좋아요",
  PO_DO_ST_02: "통풍이 잘 돼요",
  PO_DO_ST_03: "방음이 잘 돼요",
  PO_DO_ST_04: "신축이라 세련됐어요",
  PO_DO_ST_05: "곰팡이가 없어요",
  PO_DO_ST_06: "냉난방이 잘 돼요",
  PO_DO_ST_07: "배수와 수압이 좋아요",
  
  PO_DO_MT_01: "주차가 편리해요",
  PO_DO_MT_02: "엘리베이터가 있어요",
  PO_DO_MT_03: "쓰레기 처리가 편해요",
  PO_DO_MT_04: "입주비가 합리적이에요",
  PO_DO_MT_05: "인터넷이 잘 돼요",
  PO_DO_MT_06: "관리가 정기적이에요",
  PO_DO_MT_07: "입주가 편했어요",
  PO_DO_MT_08: "공용시설이 쾌적해요",
  PO_DO_MT_09: "통금이 없어요",
  PO_DO_MT_10: "휴게시설이 충분해요",
  PO_DO_MT_11: "규칙이 유연해요",

  // ✅ 부정 키워드
  NE_BD_LO_01: "교통이 불편해요",
  NE_BD_LO_02: "환경이 지저분해요",
  NE_BD_LO_03: "동네가 시끄러워요",
  NE_BD_LO_04: "공원이 멀어요",
  NE_BD_LO_05: "생활권이 불편해요",
  NE_BD_LO_06: "학교와 멀어요",
  NE_BD_LO_07: "동네가 안전하지 않아요",
  NE_BD_LO_08: "이웃들이 불친절해요",

  NE_BD_ST_01: "채광이 부족해요",
  NE_BD_ST_02: "통풍이 안돼요",
  NE_BD_ST_03: "방음이 안돼요",
  NE_BD_ST_04: "집 상태가 낡았어요",
  NE_BD_ST_05: "곰팡이가 많아요",
  NE_BD_ST_06: "냉난방이 안돼요",
  NE_BD_ST_07: "배수와 수압이 약해요",

  NE_BD_MT_01: "주차가 어려워요",
  NE_BD_MT_02: "엘리베이터가 없어요",
  NE_BD_MT_03: "쓰레기 처리가 불편해요",
  NE_BD_MT_04: "관리비가 비싸요",
  NE_BD_MT_05: "인터넷이 느려요",
  NE_BD_MT_06: "관리가 부족해요",
  NE_BD_MT_07: "이사가 힘들었어요",

  NE_AG_PD_01: "매물이 한정되어 있어요",
  NE_AG_PD_02: "허위 매물을 소개했어요",
  NE_AG_PD_03: "조건에 맞지 않은 매물만 추천했어요",
  NE_AG_PD_04: "수수료가 높았어요",

  NE_AG_SO_01: "응대가 불친절했어요",
  NE_AG_SO_02: "설명이 부족했어요",
  NE_AG_SO_03: "정보를 숨겼어요",
  NE_AG_SO_04: "처리 속도가 느렸어요",
  NE_AG_SO_05: "계약을 강요했어요",
  NE_AG_SO_06: "계약 내용 안내가 불충분했어요",
  NE_AG_SO_07: "사후 대응이 잘 안되었어요",

  NE_DO_LO_01: "교통이 불편해요",
  NE_DO_LO_02: "환경이 지저분해요",
  NE_DO_LO_03: "주변이 시끄러워요",
  NE_DO_LO_04: "생활권이 불편해요",
  NE_DO_LO_05: "학교와 멀어요",
  NE_DO_LO_06: "동네가 안전하지 않아요",

  NE_DO_ST_01: "채광이 부족해요",
  NE_DO_ST_02: "통풍이 안돼요",
  NE_DO_ST_03: "방음이 안돼요",
  NE_DO_ST_04: "건물이 낡았어요",
  NE_DO_ST_05: "곰팡이가 많아요",
  NE_DO_ST_06: "냉난방이 안돼요",
  NE_DO_ST_07: "배수와 수압이 약해요",
  
  NE_DO_MT_01: "주차가 어려워요",
  NE_DO_MT_02: "엘리베이터가 없어요",
  NE_DO_MT_03: "쓰레기 처리가 불편해요",
  NE_DO_MT_04: "입주비가 비싸요",
  NE_DO_MT_05: "인터넷이 느려요",
  NE_DO_MT_06: "관리가 부족해요",
  NE_DO_MT_07: "입주가 힘들었어요",
  NE_DO_MT_08: "공용시설이 불편해요 ",
  NE_DO_MT_09: "통금이 있어요",
  NE_DO_MT_10: "휴게시설이 불충분해요",
  NE_DO_MT_11: "규칙이 엄격해요",
};
